module.exports = "/_next/static/images/buyers_7-cc83e2dab86ff3961b01d559021e7b4b.png";